export default "__VITE_ASSET__zJ_sBDrL__"